import EventApi from '@/api/event'

const state = {
  event: null
}

const getters = {
  event: state => state.event
}

const mutations = {
  SET_EVENT: (state, event) => {
    state.event = event
  }
}

const actions = {
  async setEvent({ commit }, payload) {
    let event = await EventApi.get(payload)
    commit('SET_EVENT', event)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
